import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import LoginPage from '../pages/login/page';
import RegisterPage from '../pages/register/page';
import CreerComptePatientPage from '../pages/creer-compte-patient/page';
import ResetPasswordPage from '../pages/reset-password/page';
import RendezVousPage from '../pages/rendez-vous/page';
import AdminPage from '../pages/admin/page';
import MedecinRendezVousPage from '../pages/medecin/rendez-vous/page';
import PatientRendezVousPage from '../pages/patient/rendez-vous/page';
import DossierPatientPage from '../pages/medecin/dossier-patient/page';
import RecherchePatients from '../pages/medecin/recherche-patients/page';
import ServicesPage from '../pages/services/page';
import ContactPage from '../pages/contact/page';
import InviteDoctorPage from '../pages/admin/invite-doctor/page';
import StatistiquesPage from '../pages/admin/statistiques/page';
import ConfigurationPage from '../pages/admin/configuration/page';
import AdminSuivisPage from '../pages/admin/suivis/page';
import ActualitesPage from '../pages/actualites/page';
import ActualiteDetailPage from '../pages/actualites/detail/page';
import DisponibilitesPage from '../pages/medecin/disponibilites/page';
import MessagesContactPage from '../pages/admin/messages-contact/page';
import AdminActualitesPage from '../pages/admin/actualites/page';
import AdminAnnoncesPage from '@/pages/admin/annonces/page';
import NouveauPatientPage from '../pages/medecin/nouveau-patient/page';
import SecretairesPage from '../pages/admin/secretaires/page';
import LaborantinsPage from '../pages/admin/laborantins/page';
import LaborantinDashboardPage from '../pages/laborantin/dashboard/page';
import SaisirAnalysesPage from '../pages/laborantin/saisir-analyses/page';
import RapportAnalysesPage from '../pages/laborantin/rapport-analyses/page';
import ValeursReferencePage from '../pages/laborantin/valeurs-reference/page';
import SageFemmesPage from '../pages/admin/sage-femmes/page';
import SageFemmeDashboardPage from '../pages/sage-femme/dashboard/page';
import SageFemmeBonLaboratoirePage from '../pages/sage-femme/bon-laboratoire/page';
import SecretaireDashboardPage from '../pages/secretaire/dashboard/page';
import SecretaireNouveauRendezVousPage from '../pages/secretaire/nouveau-rendez-vous/page';
import GestionPatientsPage from '../pages/secretaire/gestion-patients/page';
import MentionsLegalesPage from '../pages/mentions-legales/page';
import PolitiqueConfidentialitePage from '../pages/politique-confidentialite/page';
import ConditionsUtilisationPage from '../pages/conditions-utilisation/page';
import GestionCookiesPage from '../pages/gestion-cookies/page';
import AccesLogsPage from '../pages/admin/acces-logs/page';
import AdministrateursPage from '../pages/admin/administrateurs/page';
import CharteDontologiePage from '../pages/charte-deontologie/page';
import EnvoyerSuiviPage from '../pages/medecin/envoyer-suivi/page';
import CreerPrescriptionPage from '../pages/medecin/creer-prescription/page';
import BonLaboratoirePage from '../pages/medecin/bon-laboratoire/page';
import MedecinNouveauRendezVousPage from '../pages/medecin/nouveau-rendez-vous/page';
import ConsultationPage from '../pages/medecin/consultation/page';
import SuiteSoinsPage from '@/pages/medecin/suite-soins/page';
import FicheVisitePage from '@/pages/medecin/fiche-visite/page';
import GuideMedecinPage from '@/pages/medecin/guide/page';
import MaintenancePage from '../pages/maintenance/page';
import ChangePasswordPage from '../pages/change-password/page';
import ChangePasswordMedecinPage from '../pages/change-password-medecin/page';
import AdminSessionsPage from '../pages/admin/sessions/page';
import AdminRendezVousPage from '../pages/admin/rendez-vous/page';
import AdminPatientsPage from '../pages/admin/patients/page';
import BotHoneypotPage from '@/pages/bot-honeypot/page';
import ProfilPage from '@/pages/profil/page';
import VerifierDocumentPage from '@/pages/verifier-document/page';
import JeuxPage from '@/pages/jeux/page';
import PuzzleCorpsHumain from '@/pages/jeux/games/puzzle-corps-humain/page';
import MemoryGame from '@/pages/jeux/games/memory/page';
import QuizSante from '@/pages/jeux/games/quiz-sante/page';
import PuzzleClassique from '@/pages/jeux/games/puzzle-classique/page';
import TicTacToe from '@/pages/jeux/games/tic-tac-toe/page';
import SnakeGame from '@/pages/jeux/games/snake/page';
import Game2048 from '@/pages/jeux/games/2048/page';
import SudokuGame from '@/pages/jeux/games/sudoku/page';
import PenduGame from '@/pages/jeux/games/pendu/page';
import MotsCroises from '@/pages/jeux/games/mots-croises/page';
import DragDropGame from '@/pages/jeux/games/drag-drop/page';
import LabyrintheGame from '@/pages/jeux/games/labyrinthe/page';
import TrouveDifferences from '@/pages/jeux/games/trouve-differences/page';
import ImportPatientsCsvPage from '../pages/admin/import-patients-csv/page';
import CorrectionPatientsPage from '@/pages/admin/corrections-patients/page';
import ImportNumerosReservesPage from '@/pages/admin/import-numeros-reserves/page';
import AdminMedicamentsPage from '@/pages/admin/medicaments/page';
import InfirmiersPage from '@/pages/admin/infirmiers/page';
import AdminAssurancesPage from '@/pages/admin/assurances/page';
import AdminConsultationsPage from '@/pages/admin/consultations/page';
import InfirmierDashboardPage from '@/pages/infirmier/dashboard/page';
import FileAttentePage from '@/pages/file-attente/page';
import VisioconferencePage from '@/pages/visioconference/page';
import ReunionPage from '@/pages/visioconference/reunion/page';
import AdminVideoMeetingsPage from '@/pages/admin/video-meetings/page';
import ComptablesPage from '@/pages/admin/comptables/page';
import ComptableDashboardPage from '../pages/comptable/dashboard/page';
import TelecommandeClavierPage from '../pages/telecommande-clavier/page';
import MeetPage from '@/pages/meet/page';
import MeetReunionPage from '@/pages/meet/reunion/page';
import AdminBonsLaboratoirePage from '@/pages/admin/bons-laboratoire/page';
import Admin2faPage from '@/pages/admin/2fa/page';

const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/maintenance',
    element: <MaintenancePage />,
  },
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/creer-compte-patient',
    element: <CreerComptePatientPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/change-password',
    element: <ChangePasswordPage />,
  },
  {
    path: '/change-password-medecin',
    element: <ChangePasswordMedecinPage />,
  },
  {
    path: '/rendez-vous',
    element: <RendezVousPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/actualites',
    element: <ActualitesPage />,
  },
  {
    path: '/actualites/:id',
    element: <ActualiteDetailPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialitePage />,
  },
  {
    path: '/conditions-utilisation',
    element: <ConditionsUtilisationPage />,
  },
  {
    path: '/gestion-cookies',
    element: <GestionCookiesPage />,
  },
  {
    path: '/charte-deontologie',
    element: <CharteDontologiePage />,
  },
  // Jeux éducatifs
  {
    path: '/jeux',
    element: <JeuxPage />,
  },
  {
    path: '/jeux/puzzle-corps-humain',
    element: <PuzzleCorpsHumain />,
  },
  {
    path: '/jeux/memory',
    element: <MemoryGame />,
  },
  {
    path: '/jeux/quiz-sante',
    element: <QuizSante />,
  },
  {
    path: '/jeux/puzzle-classique',
    element: <PuzzleClassique />,
  },
  {
    path: '/jeux/tic-tac-toe',
    element: <TicTacToe />,
  },
  {
    path: '/jeux/snake',
    element: <SnakeGame />,
  },
  {
    path: '/jeux/2048',
    element: <Game2048 />,
  },
  {
    path: '/jeux/sudoku',
    element: <SudokuGame />,
  },
  {
    path: '/jeux/pendu',
    element: <PenduGame />,
  },
  {
    path: '/jeux/mots-croises',
    element: <MotsCroises />,
  },
  {
    path: '/jeux/drag-drop',
    element: <DragDropGame />,
  },
  {
    path: '/jeux/labyrinthe',
    element: <LabyrintheGame />,
  },
  {
    path: '/jeux/trouve-differences',
    element: <TrouveDifferences />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin/suivis',
    element: <AdminSuivisPage />
  },
  {
    path: '/admin/invite-doctor',
    element: <InviteDoctorPage />
  },
  {
    path: '/admin/statistiques',
    element: <StatistiquesPage />
  },
  {
    path: '/admin/configuration',
    element: <ConfigurationPage />
  },
  {
    path: '/admin/2fa',
    element: <Admin2faPage />
  },
  {
    path: '/admin/sessions',
    element: <AdminSessionsPage />,
  },
  {
    path: '/admin/messages-contact',
    element: <MessagesContactPage />
  },
  {
    path: '/admin/messages-contact/:messageId',
    element: <MessagesContactPage />
  },
  {
    path: '/admin/actualites',
    element: <AdminActualitesPage />
  },
  {
    path: '/admin/annonces',
    element: <AdminAnnoncesPage />
  },
  {
    path: '/admin/secretaires',
    element: <SecretairesPage />
  },
  {
    path: '/admin/laborantins',
    element: <LaborantinsPage />
  },
  {
    path: '/admin/acces-logs',
    element: <AccesLogsPage />
  },
  {
    path: '/admin/administrateurs',
    element: <AdministrateursPage />
  },
  {
    path: '/admin/rendez-vous',
    element: <AdminRendezVousPage />,
  },
  {
    path: '/admin/patients',
    element: <AdminPatientsPage />,
  },
  {
    path: '/admin/import-patients-csv',
    element: <ImportPatientsCsvPage />,
  },
  {
    path: '/admin/corrections-patients',
    element: <CorrectionPatientsPage />,
  },
  {
    path: '/admin/import-numeros-reserves',
    element: <ImportNumerosReservesPage />,
  },
  {
    path: '/admin/medicaments',
    element: <AdminMedicamentsPage />,
  },
  {
    path: '/admin/infirmiers',
    element: <InfirmiersPage />,
  },
  {
    path: '/admin/assurances',
    element: <AdminAssurancesPage />,
  },
  {
    path: '/admin/consultations',
    element: <AdminConsultationsPage />,
  },
  {
    path: '/admin/bons-laboratoire',
    element: <AdminBonsLaboratoirePage />,
  },
  {
    path: '/admin/video-meetings',
    element: <AdminVideoMeetingsPage />,
  },
  {
    path: '/admin/comptables',
    element: <ComptablesPage />,
  },
  {
    path: '/admin/sage-femmes',
    element: <SageFemmesPage />
  },
  {
    path: '/medecin/rendez-vous',
    element: <MedecinRendezVousPage />,
  },
  {
    path: '/medecin/disponibilites',
    element: <DisponibilitesPage />,
  },
  {
    path: '/medecin/dossier-patient/:patientId',
    element: <DossierPatientPage />,
  },
  {
    path: '/medecin/dossier-patient',
    element: <DossierPatientPage />,
  },
  {
    path: '/medecin/envoyer-suivi',
    element: <EnvoyerSuiviPage />,
  },
  {
    path: '/medecin/creer-prescription',
    element: <CreerPrescriptionPage />,
  },
  {
    path: '/medecin/bon-laboratoire',
    element: <BonLaboratoirePage />,
  },
  {
    path: '/medecin/consultation',
    element: <ConsultationPage />,
  },
  {
    path: '/medecin/suite-soins',
    element: <SuiteSoinsPage />,
  },
  {
    path: '/medecin/fiche-visite',
    element: <FicheVisitePage />,
  },
  {
    path: '/medecin/guide',
    element: <GuideMedecinPage />,
  },
  {
    path: '/patient/rendez-vous',
    element: <PatientRendezVousPage />,
  },
  {
    path: '/medecin/recherche-patients',
    element: <RecherchePatients />,
  },
  {
    path: '/medecin/nouveau-patient',
    element: <NouveauPatientPage />,
  },
  {
    path: '/medecin/nouveau-rendez-vous',
    element: <MedecinNouveauRendezVousPage />,
  },
  {
    path: '/secretaire/dashboard',
    element: <SecretaireDashboardPage />,
  },
  {
    path: '/secretaire/nouveau-rendez-vous',
    element: <SecretaireNouveauRendezVousPage />,
  },
  {
    path: '/secretaire/gestion-patients',
    element: <GestionPatientsPage />,
  },
  {
    path: '/laborantin/dashboard',
    element: <LaborantinDashboardPage />,
  },
  {
    path: '/infirmier/dashboard',
    element: <InfirmierDashboardPage />,
  },
  {
    path: '/comptable/dashboard',
    element: <ComptableDashboardPage />,
  },
  {
    path: '/laborantin/saisir-analyses',
    element: <SaisirAnalysesPage />,
  },
  {
    path: '/laborantin/rapport-analyses/:dossierId',
    element: <RapportAnalysesPage />,
  },
  {
    path: '/laborantin/valeurs-reference',
    element: <ValeursReferencePage />,
  },
  {
    path: '/sage-femme/dashboard',
    element: <SageFemmeDashboardPage />,
  },
  {
    path: '/sage-femme/bon-laboratoire',
    element: <SageFemmeBonLaboratoirePage />,
  },
  {
    path: '/sage-femme/dossier-patient/:patientId',
    element: <DossierPatientPage />,
  },
  {
    path: '/sage-femme/dossier-patient',
    element: <DossierPatientPage />,
  },
  {
    path: '/mon-profil',
    element: <ProfilPage />,
  },
  {
    path: '/verifier-document',
    element: <VerifierDocumentPage />,
  },
  {
    path: '/bot-honeypot',
    element: <BotHoneypotPage />,
  },
  {
    path: '/file-attente',
    element: <FileAttentePage />,
  },
  {
    path: '/visioconference',
    element: <VisioconferencePage />,
  },
  {
    path: '/visioconference/reunion/:code',
    element: <ReunionPage />,
  },
  {
    path: '/telecommande-clavier',
    element: <TelecommandeClavierPage />,
  },
  {
    path: '/meet',
    element: <MeetPage />,
  },
  {
    path: '/meet/:code',
    element: <MeetReunionPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;